import React, { useCallback, useRef, useState } from 'react';
import { createLink } from 'roosterjs-editor-api';
import styled from 'styled-components';
import { useFormatState, useToolbarActionContext } from '../context';
import { CommandButton } from './command-button';
import { IEditorToolbarActionBaseProps } from './types';
import { Callout } from '../../../callout';
import { StackPanel } from '../../../stack-panel';
import { Typography } from '../../../typography';
import { Textbox } from '../../../textbox';
import { DefaultButton, PrimaryButton } from '../../../button';
import { selectThemeSemantics } from '../../../../styling';

const StyledStackPanel = styled(StackPanel)`
    width: 300px;
    padding: ${selectThemeSemantics(({ gap }) => gap.l)};
`;

const FullWidthStackPanel = styled(StackPanel)`
    width: 100%;
`;

const StyledTextbox = styled(Textbox)`
    width: 100%;
`;

export function InsertHyperlinkAction(props: IEditorToolbarActionBaseProps) {
    const itemRef = useRef<HTMLSpanElement>(null);
    const [isCalloutHidden, setCalloutHiddenStatus] = useState(true);
    const [url, setUrl] = useState('');
    const [displayName, setDisplayName] = useState('');
    const { editor } = useToolbarActionContext();
    const { canUnlink } = useFormatState();

    const showCallout = useCallback(() => {
        setCalloutHiddenStatus(false);
    }, []);

    const hideCallout = useCallback(() => {
        setDisplayName('');
        setUrl('');
        setCalloutHiddenStatus(true);
    }, []);

    const submitValue = useCallback(() => {
        createLink(editor, url, displayName, displayName);
        hideCallout();
    }, [displayName, editor, hideCallout, url]);

    return canUnlink ? null : (
        <>
            <CommandButton {...props} tooltip="Insert Hyperlink" iconName="ap-insert-link.rte" elementRef={itemRef} onClick={showCallout} />
            <Callout offset={-5} hidden={isCalloutHidden} isBeakVisible targetRef={itemRef} onDismiss={hideCallout}>
                <StyledStackPanel orientation="vertical" gap="12">
                    <Typography.H5>Insert Hyperlink</Typography.H5>
                    <FullWidthStackPanel orientation="vertical">
                        <Typography.Small key="url">URL:</Typography.Small>
                        <StyledTextbox key="url-value" placeholder="Enter URL" value={url} onValueChange={setUrl} />
                    </FullWidthStackPanel>
                    <FullWidthStackPanel orientation="vertical">
                        <Typography.Small key="text">Display Text:</Typography.Small>
                        <StyledTextbox key="display-value" placeholder="Enter Display Name" value={displayName} onValueChange={setDisplayName} />
                    </FullWidthStackPanel>
                    <FullWidthStackPanel orientation="horizontal" justifyContent="right" inline={false}>
                        <DefaultButton label="Cancel" onClick={hideCallout} size="small" />
                        <PrimaryButton label="Insert" onClick={submitValue} size="small" />
                    </FullWidthStackPanel>
                </StyledStackPanel>
            </Callout>
        </>
    );
}
